<!--
 * @Description: 用户注册组件
 * @Author: hai-27
 * @Date: 2020-02-19 22:20:35
 * @LastEditors: hai-27
 * @LastEditTime: 2020-03-01 15:34:34
 -->
<template>
  <div id="register">
    <el-dialog title="注册" width="300px" center :visible.sync="isRegister" :close-on-click-modal="false">
      <el-form
        :model="RegisterUser"
        :rules="rules"
        status-icon
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item prop="email">
          <el-input
              prefix-icon="el-icon-receiving"
              placeholder="请输入邮箱"
              v-model="RegisterUser.email"
          ></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input v-model="RegisterUser.code" prefix-icon="el-icon-stopwatch">
            <el-button
                :disabled="counting"
                @click="sendCode" slot="append"
            >
              {{ counting ? `${count}秒后重新发送` : '发送验证码' }}
            </el-button>
          </el-input>
        </el-form-item>

        <el-form-item prop="name">
          <el-input
            prefix-icon="el-icon-user-solid"
            placeholder="请输入账号"
            v-model="RegisterUser.name"
          ></el-input>
        </el-form-item>
        <el-form-item prop="pass">
          <el-input
            prefix-icon="el-icon-view"
            type="password"
            placeholder="请输入密码"
            v-model="RegisterUser.pass"
          ></el-input>
        </el-form-item>
        <el-form-item prop="confirmPass">
          <el-input
            prefix-icon="el-icon-view"
            type="password"
            placeholder="请再次输入密码"
            v-model="RegisterUser.confirmPass"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" type="primary" @click="Register" style="width:100%;">注册</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "MyRegister",
  props: ["register"],
  data() {
    let validateEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入邮箱"));
      }
      const emailRule = /\w+@\w+(\.\w+)+/;
      if(emailRule.test(value)){
        return callback();
      }else {
        return callback(
            new Error("邮箱格式不正确")
        );
      }
    };
    // 用户名的校验方法
    let validateName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入用户名"));
      }
      // 用户名以字母开头,长度在5-16之间,允许字母数字下划线
      const userNameRule = /^[a-zA-Z][a-zA-Z0-9_]{4,15}$/;
      if (userNameRule.test(value)) {
        //判断数据库中是否已经存在该用户名
        this.$axios
          .get("/api/mall/member/findLoginName", {
            params: {
              loginName: this.RegisterUser.name
            }
          })
          .then(res => {
            // “001”代表用户名不存在，可以注册
            if (res.data.code == "200") {
              this.$refs.ruleForm.validateField("checkPass");
              return callback();
            } else {
              return callback(new Error(res.data.message));
            }
          })
          .catch(err => {
            return Promise.reject(err);
          });
      } else {
        return callback(new Error("字母开头,长度5-16之间,允许字母数字下划线"));
      }
    };
    // 密码的校验方法
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入密码"));
      }
      // 密码以字母开头,长度在6-18之间,允许字母数字和下划线
      const passwordRule = /^[a-zA-Z]\w{5,17}$/;
      if (passwordRule.test(value)) {
        this.$refs.ruleForm.validateField("checkPass");
        return callback();
      } else {
        return callback(
          new Error("字母开头,长度6-18之间,允许字母数字和下划线")
        );
      }
    };
    // 确认密码的校验方法
    let validateConfirmPass = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入确认密码"));
      }
      // 校验是否以密码一致
      if (this.RegisterUser.pass != "" && value === this.RegisterUser.pass) {
        this.$refs.ruleForm.validateField("checkPass");
        return callback();
      } else {
        return callback(new Error("两次输入的密码不一致"));
      }
    };
    return {
      isRegister: false, // 控制注册组件是否显示
      RegisterUser: {
        email: "",
        code: "",
        name: "",
        pass: "",
        confirmPass: ""
      },
      // 用户信息校验规则,validator(校验方法),trigger(触发方式),blur为在组件 Input 失去焦点时触发
      rules: {
        email: [{ validator: validateEmail, trigger: "blur" }],
        name: [{ validator: validateName, trigger: "blur" }],
        pass: [{ validator: validatePass, trigger: "blur" }],
        confirmPass: [{ validator: validateConfirmPass, trigger: "blur" }]
      },
      counting: false,
      count: 60
    };
  },
  watch: {
    // 监听父组件传过来的register变量，设置this.isRegister的值
    register: function(val) {
      if (val) {
        this.isRegister = val;
      }
    },
    // 监听this.isRegister变量的值，更新父组件register变量的值
    isRegister: function(val) {
      if (!val) {
        this.$refs["ruleForm"].resetFields();
        this.$emit("fromChild", val);
      }
    }
  },
  methods: {
    async sendCode() {
      this.$refs.ruleForm.validateField('email', emailError  => {
        if (!emailError) {
          this.counting = true;
          const timer = setInterval(() => {
            if (this.count > 1) {
              this.count--;
            } else {
              this.counting = false;
              this.count = 60; // 重置倒计时时间
              clearInterval(timer);
            }
          }, 1000);
          this.$axios
              .get("/api/mall/email/getCode?email="+this.RegisterUser.email)
              .then(res => {
                // console.log(res)
                // // “001”代表注册成功，其他的均为失败
                if (res.data.code === 200) {
                  // 弹出通知框提示注册成功信息
                  this.notifySucceed("验证码已发送");
                } else {
                  // 弹出通知框提示注册失败信息
                  this.notifyError(res.data.message);
                }
              })
              .catch(err => {
                return Promise.reject(err);
              });
        }else {
          return false;
        }
      })
    },
    Register() {
      // 通过element自定义表单校验规则，校验用户输入的用户信息
      this.$refs["ruleForm"].validate(valid => {
        //如果通过校验开始注册
        if (valid) {
          this.$axios
            .post("/api/mall/member/register", {
              email: this.RegisterUser.email,
              code: this.RegisterUser.code,
              loginName: this.RegisterUser.name,
              password: this.RegisterUser.pass
            })
            .then(res => {
              // console.log(res)
              // “001”代表注册成功，其他的均为失败
              if (res.data.code === 200) {
                // console.log("1111")
                // 隐藏注册组件
                this.isRegister = false;
                // 弹出通知框提示注册成功信息
                this.notifySucceed("注册成功");
              } else {
                // console.log("aaaa")
                // 弹出通知框提示注册失败信息
                this.notifyError(res.data.message);
              }
            })
            .catch(err => {
              return Promise.reject(err);
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style>
</style>